const prefix = ['app', 'queue', 'global'];

export const preferenceSelector = state =>
  state.getIn([...prefix, 'preference']);
export const selectedQueueSelector = state =>
  state.getIn([...prefix, 'selectedQueue']);
export const selectedQueueWorkItemSelector = state =>
  state.getIn([...prefix, 'selectedQueueWorkItem']);
